import { render, staticRenderFns } from "./BracketItem.vue?vue&type=template&id=990b6c7c&scoped=true"
import script from "./BracketItem.vue?vue&type=script&lang=js"
export * from "./BracketItem.vue?vue&type=script&lang=js"
import style0 from "./BracketItem.vue?vue&type=style&index=0&id=990b6c7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990b6c7c",
  null
  
)

export default component.exports